import React from 'react'

export const Sample1 = props => {
  return <p>Sample1</p>
}
